/* eslint-disable max-len */
import { Card, Col, Row, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import DealershipTranslatedTextAreaField from '../../../../components/fields/DealershipFields/DealershipTranslatedTextArea';
import DealershipTranslationTextField from '../../../../components/fields/DealershipFields/DealershipTranslationTextField';
import SingleUploadField from '../../../../components/fields/SingleUploadField';
import FormFields from '../../../../themes/admin/Fields/FormFields';
import { allowedExtensions } from '../../../../utilities/extensions';
import useMarkDownInfoTooltip from '../../../../utilities/useMarkDownInfoTooltip';
import useSystemSwitchData from '../../../../utilities/useSystemSwitchData';

type MobilityModuleEmailFormProps = {
    name: string;
    headerKey: string;
    targetDealerId?: string;
    dealerIds: string[];
    defaultValueDisabled: boolean;
    disabled?: boolean;
};

const MobilityModuleEmailForm = ({
    name,
    headerKey,
    dealerIds,
    targetDealerId,
    defaultValueDisabled,
    disabled,
}: MobilityModuleEmailFormProps) => {
    const { t } = useTranslation('mobilityModuleDetails');
    const markdownInfoTooltip = useMarkDownInfoTooltip();

    const { yesNoSwitch } = useSystemSwitchData();

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <Card title={t(`mobilityModuleDetails:emails.${headerKey}`)}>
                <Row gutter={10}>
                    <Col lg={8} xs={24}>
                        <DealershipTranslationTextField
                            {...t('mobilityModuleDetails:fields.emails.subject', { returnObjects: true })}
                            dealerIds={dealerIds}
                            defaultValueDisabled={defaultValueDisabled}
                            disabled={disabled}
                            name={`${name}.subject`}
                            tooltip={markdownInfoTooltip}
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <DealershipTranslationTextField
                            {...t('mobilityModuleDetails:fields.emails.introTitle', { returnObjects: true })}
                            dealerIds={dealerIds}
                            defaultValueDisabled={defaultValueDisabled}
                            disabled={disabled}
                            name={`${name}.introTitle`}
                            tooltip={markdownInfoTooltip}
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <DealershipTranslatedTextAreaField
                            {...t('mobilityModuleDetails:fields.emails.contentText', { returnObjects: true })}
                            defaultValueDisabled={defaultValueDisabled}
                            disabled={disabled}
                            name={`${name}.contentText`}
                            targetDealerId={targetDealerId}
                            tooltip={markdownInfoTooltip}
                            withContentRefinement
                        />
                    </Col>
                    <Col lg={8} xs={24}>
                        <SingleUploadField
                            disabled={disabled}
                            extensions={allowedExtensions.image}
                            {...t('mobilityModuleDetails:fields.emails.introImage', { returnObjects: true })}
                            name={`${name}.introImage`}
                        />
                    </Col>

                    <Col lg={8} xs={24}>
                        <FormFields.SwitchField
                            {...t('mobilityModuleDetails:fields.emails.isEmailEnabled', {
                                returnObjects: true,
                            })}
                            {...yesNoSwitch}
                            disabled={disabled}
                            name={`${name}.isEmailEnabled`}
                        />
                    </Col>
                </Row>
            </Card>
        </Space>
    );
};

export default MobilityModuleEmailForm;
